import { Fragment } from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Meta from "modules/Meta";
import Footer from "container/home/Footer";
import NavbarResources from "components/organism/Navbar/NavbarResources";

const ResourceLayouts = ({ title, children }) => {
    const currentLocation = useLocation().pathname;

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    }, [currentLocation, title]);
    return (
        <Fragment>
            <NavbarResources />
            <Meta title={title} />
            {children}
            <Footer />
        </Fragment>
    );
};

export default ResourceLayouts;